import { render, staticRenderFns } from "./ModuleTree.vue?vue&type=template&id=54ca7fd0&scoped=true&"
import script from "./ModuleTree.vue?vue&type=script&lang=ts&"
export * from "./ModuleTree.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleTree.vue?vue&type=style&index=0&id=54ca7fd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ca7fd0",
  null
  
)

export default component.exports